import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import LoginPage from "./components/Login/LoginPage";
import HomePage from "./pages/HomePage/HomePage";
import BuyerProfilePage from "./pages/BuyerProfilePage/BuyerProfilePage";
// import Overview from "./components/BuyerProfile/Overview";
// import ProfileDetails from "./components/BuyerProfile/ProfileDetails";
// import Wishlist from "./components/BuyerProfile/Wishlist";
// import Following from "./components/BuyerProfile/Following/Following";
import CategoriesPage from "./pages/CategoriesPage/CategoriesPage";
import ProductId from "./pages/ProductIdPage/ProductIdPage";
import AllProductsPage from "./pages/AllProductsPage/AllProductsPage";
import { ordersLink } from "./routes/routes";
import { StoreManagerLink } from "./routes/routes";
import { getAuth, onAuthStateChanged } from "@firebase/auth";
import { createContext, useEffect, useState } from "react";
import WebFrontPage from "./pages/WebFrontPage/WebFrontPage";
// import Orders from "./components/BuyerProfile/Orders";
import Inquiry from "./components/BuyerProfile/Inquiry";
import SellerDashboardPage from "./pages/SellerDashboardPage/SellerDashboardPage";
import SellerOverview from "./components/SellerDashboard/SellerOverview";
import MyProducts from "./components/SellerDashboard/MyProducts";
import SellerFollowers from "./components/SellerDashboard/SellerFollowers";
import SellerPayment from "./components/SellerDashboard/Payment/SellerPayment";

import AboutMyStore from "./components/SellerDashboard/MyStore/AboutMyStore";
import MyStoreContact from "./components/SellerDashboard/MyStore/MyStoreContact";
import MyStoreOverview from "./components/SellerDashboard/MyStore/MyStoreOverview";
import MyStoreProducts from "./components/SellerDashboard/MyStore/MyStoreProducts";

import PaymentSettings from "./components/SellerDashboard/Payment/PaymentSettings";

import OrderApproval from "./components/UI/SellerOrder/OrderApproval";
import OrderDetails from "./components/UI/SellerOrder/OrderDetails";

import RaiseTicket from "./components/UI/SupportTickets/RaiseTicket";
import TicketDetails from "./components/UI/SupportTickets/TicketDetails";

import TrackOrder from "./components/UI/Orders/TrackOrder";
import ViewDetails from "./components/UI/Orders/ViewDetails";

import UploadDocuments from "./components/UI/StoreManagerForm/UploadDocuments";
import SellerType from "./components/UI/StoreManagerForm/SellerType";
import RegisterPricingPlan from "./components/UI/StoreManagerForm/RegisterPricingPlan";

import LogOut from "./components/UI/LogOut";

import GetLoanPage from "./pages/LoanPage/LoanPage";
import LandingPage from "./components/LandingPage/LandingPage";
import QuotationFormPage from "./pages/QuotationPage/QuotationPage";

import ProtectedRoute from "./ProtectedRoute";
import { CurrencyProvider } from "./provider/CurrencyProvider";
import Member from "./components/UI/Member";

export const UserAuthContext = createContext();

function App() {
  const [userUid, setUserUid] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const auth = getAuth();

    onAuthStateChanged(auth, (user) => {
      if (user) setIsLoggedIn(true);
      else setIsLoggedIn(false);
    });
    setUserUid(auth);
  }, []);

  return (
    <UserAuthContext.Provider value={{ userUid, isLoggedIn }}>
      <CurrencyProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/*" element={<HomePage />} />
            <Route path="/LandingPage" element={<LandingPage />} />

            <Route path="/Member" element={<Member />} />
            <Route path="/login" element={<LoginPage />} />
            {/* <Route path="/orders" element={<BuyerProfilePage />} />
        <Route path="/Overview" element={<Overview />} />
        <Route path="/ProfileDetails" element={<ProfileDetails />} />
        <Route path="/Whishlist" element={<Wishlist />} />
        <Route path="/Following" element={<Following />} />
        <Route path="/ordersPage" element={<Orders />} /> */}
            <Route
              path="/orders"
              element={<ProtectedRoute element={<BuyerProfilePage />} />}
            >
              {ordersLink.map((order) => (
                <Route path={order.url} element={order.element}>
                  {order.children &&
                    order.children.map((childern) => (
                      <Route path={childern.url} element={childern.element} />
                    ))}
                </Route>
              ))}
            </Route>

            <Route
              path="/SellerDashboard"
              // element={<ProtectedRoute element={<SellerDashboardPage />} />}
              element={<SellerDashboardPage />}
            >
              {StoreManagerLink.map((order) => (
                <Route path={order.url} element={order.element}>
                  {order.children &&
                    order.children.map((childern) => (
                      <Route path={childern.url} element={childern.element} />
                    ))}
                </Route>
              ))}
            </Route>
            <Route path="/Categories" element={<CategoriesPage />} />
            <Route path="/productId/:productId" element={<ProductId />} />
            <Route path="/AllProductsPage" element={<AllProductsPage />} />

            <Route path="/RaiseTicket" element={<RaiseTicket />} />
            <Route path="/TicketDetails" element={<TicketDetails />} />

            <Route path="/TrackOrder" element={<TrackOrder />} />
            <Route path="/ViewDetails" element={<ViewDetails />} />
            <Route path="/WebFrontPage" element={<WebFrontPage />} />
            <Route path="/Inquiry" element={<Inquiry />} />
            {/* <Route path="/SellerDashboard" element={<SellerDashboardPage />} /> */}
            <Route path="/SellerOverview" element={<SellerOverview />} />
            <Route path="/MyProducts" element={<MyProducts />} />
            <Route path="/SellerFollowers" element={<SellerFollowers />} />
            <Route path="/SellerPayment" element={<SellerPayment />} />

            <Route path="/AboutMyStore" element={<AboutMyStore />} />
            <Route path="/MyStoreContact" element={<MyStoreContact />} />
            <Route path="/MyStoreOverview" element={<MyStoreOverview />} />
            <Route path="/MyStoreProducts" element={<MyStoreProducts />} />

            <Route path="/PaymentSettings" element={<PaymentSettings />} />

            <Route
              path="/SellerDashboard/ReceivedOrders/:orderId"
              element={<OrderApproval />}
            />
            <Route
              path="/SellerDashboard/ReceivedOrders/OrderDetails/:orderId"
              element={<OrderDetails />}
            />

            <Route path="/OrderApproval" element={<OrderApproval />} />
            <Route path="/OrderDetails" element={<OrderDetails />} />

            <Route path="/UploadDocuments" element={<UploadDocuments />} />
            <Route path="/SellerType" element={<SellerType />} />
            <Route path="/LogOut" element={<LogOut />} />
            <Route
              path="/RegisterPricingPlan"
              element={<RegisterPricingPlan />}
            />

            <Route path="/GetLoanPage" element={<GetLoanPage />} />
            <Route path="/QuotationFormPage" element={<QuotationFormPage />} />
          </Routes>
        </BrowserRouter>
      </CurrencyProvider>
    </UserAuthContext.Provider>
  );
}

export default App;
